exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrap {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-pack: center;\r\n        -ms-flex-pack: center;\r\n            justify-content: center;\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center;\r\n    height: 100%;\r\n    padding: 20px;\r\n    margin-top: 15%;\r\n}\r\n\r\n.pic {\r\n    width: 239px;\r\n    height: 161px;\r\n}\r\n\r\n.tips {\r\n    font-size: 24px;\r\n    color: #908e8e;\r\n    text-align: center;\r\n}\r\n\r\n.jump-btn {\r\n    border: 2px solid #07b6e0;\r\n    color: #07b6e0;\r\n    display: inline-block;\r\n    font-size: 20px;\r\n    padding: 5px;\r\n    cursor: pointer;\r\n    margin-top: 20px;\r\n}\r\n\r\n.jump-btn:hover {\r\n    background-color: #07b6e0;\r\n    color: #fff;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// F:/WMS/X-xiamenzhuhe-SDM234/zhuhe-234/sdm_fe/src/app/home/components/notFound/notFound.component.css
// module id = ../../../../../src/app/home/components/notFound/notFound.component.css
// module chunks = main